import { useExperiment, ExperimentValue } from '@app/experiments';
import { EXPERIMENTS } from '@app/config';

interface UseShowFavoritePage {
  showFavoritesPage: ExperimentValue;
  milestone: number;
}

const useShowFavoritesPage = (): UseShowFavoritePage => {
  const showFavoritesPageMilestoneOne = useExperiment(
    EXPERIMENTS.feature_flag_show_favorites_page_web,
  );

  const showFavoritesPageMilestoneTwo = useExperiment(
    EXPERIMENTS.feature_flag_show_favorites_page_web_r2,
  );

  return {
    showFavoritesPage:
      showFavoritesPageMilestoneOne || showFavoritesPageMilestoneTwo,
    milestone: showFavoritesPageMilestoneTwo ? 2 : 1,
  };
};

export default useShowFavoritesPage;
